let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWaws"), load("g6G0R")]).then(() => parcelRequire('aNhwL'));